import React, { useState, useEffect } from 'react';
import './styles.css';

const PCRecommendModal = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Check if user has seen the modal before
        const hasSeenModal = localStorage.getItem('hasSeenPCModal');
        if (!hasSeenModal) {
            setIsVisible(true);
        }
    }, []);

    useEffect(() => {
        // Disable scrolling when modal is open
        if (isVisible) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }

        // Cleanup function to restore scrolling
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isVisible]);

    const handleClose = () => {
        localStorage.setItem('hasSeenPCModal', 'true');
        setIsVisible(false);
    };

    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                handleClose();
            }
        };

        if (isVisible) {
            document.addEventListener('keydown', handleEscape);
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [isVisible]);

    if (!isVisible) return null;

    return (
        <div className="pc-recommend-modal-overlay" onClick={handleClose}>
            <div className="pc-recommend-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Heads Up!</h2>
                </div>
                <div className="modal-body">
                    <p>
                        This site was designed primarily for desktop viewing. While the mobile
                        version works, you'll get a <i>significantly better experience</i> on
                        a larger screen.
                    </p>
                    <p className="modal-subtext">
                        Think of this as the trailer. The desktop version is the full feature.
                    </p>
                </div>
                <button className="modal-close-btn" onClick={handleClose}>
                    Continue Anyway
                </button>
            </div>
        </div>
    );
};

export default PCRecommendModal;
